function EnrichmentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width=".984"
        d="m4.149 14.973 2.901-7.71a.85.85 0 0 1 1.59-.004l2.957 7.714m-5.982-3.427h4.541M14.84 6.66v8.351"
      />
      <path
        fill="currentColor"
        d="m16.087 1.28 1.078.566a.266.266 0 0 1 0 .479l-1.078.562a.281.281 0 0 0-.114.11l-.59 1.032a.29.29 0 0 1-.499 0l-.587-1.032a.281.281 0 0 0-.114-.11l-1.078-.562a.266.266 0 0 1 0-.48l1.078-.564a.281.281 0 0 0 .114-.11l.59-1.03a.29.29 0 0 1 .5 0l.589 1.03a.26.26 0 0 0 .111.11Zm3.706 3.657.642.336a.159.159 0 0 1 0 .285l-.642.337a.167.167 0 0 0-.067.065l-.352.614a.175.175 0 0 1-.299 0l-.348-.616a.167.167 0 0 0-.068-.065l-.641-.336a.16.16 0 0 1 0-.287l.641-.336a.167.167 0 0 0 .068-.065l.351-.613a.175.175 0 0 1 .3 0l.35.614a.14.14 0 0 0 .065.067ZM19.606.934l.428.225c.055.03.075.096.046.148a.12.12 0 0 1-.046.043l-.428.225a.111.111 0 0 0-.046.043l-.234.41a.118.118 0 0 1-.154.044.12.12 0 0 1-.046-.043l-.234-.41a.111.111 0 0 0-.045-.044l-.429-.225a.108.108 0 0 1 0-.191l.429-.225a.111.111 0 0 0 .045-.043l.234-.41a.117.117 0 0 1 .155-.044c.019.01.034.025.045.043l.234.41c.01.02.027.035.046.044Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.047"
        d="M19.663 10.072v5.343a4.49 4.49 0 0 1-1.401 3.242A4.893 4.893 0 0 1 14.878 20h-9.57a4.893 4.893 0 0 1-3.383-1.343 4.49 4.49 0 0 1-1.402-3.242V6.246a4.49 4.49 0 0 1 1.402-3.242 4.893 4.893 0 0 1 3.383-1.343h5.386"
      />
    </svg>
  );
}

export default EnrichmentIcon;
